import React, { useState } from "react";
import store from "@root/redux/store";
import { useFlipper } from "services/api/flipper";

import {
  AuthorizeWhatsapp,
  AutoEnroll,
  CellPhone,
  CPF,
  DateOfBirth,
  Email,
  Ethnicity,
  Gender,
  Sex,
  Name,
  Working,
  Nationality,
  CurriculumVitae,
  MaritalStatus,
  JobInterests,
  InstitutionalEmail,
} from "components/users/fields/essential";

import {
  Course,
  University,
  CurrentSemester,
  FormationDate,
  NotInUniversity,
  MainEducationType,
  IesPeriod,
  MainEducationStatus,
  IesEducationType,
} from "components/users/fields/academic";

import { SocialName, RG } from "components/users/fields/personal";

import DisabilitySection from "./sections/DisabilitySection";

const GENDER_MALE_ID = 1;
const GENDER_FEMALE_ID = 2;

const OldEssential = (props) => {
  const notInUniversity =
    props.getValues?.("not_in_university")?.toString() || false;
  const [showAcademic, setShowAcademic] = useState(notInUniversity !== "true");
  const [genderId, setGenderId] = useState(null);

  const user = store.getState().session?.attributes;

  const handleShowAcademic = (value) => {
    setShowAcademic(value !== "true");
  };

  const handleGender = (value) => {
    setGenderId(value);
  };

  function renderSocialName() {
    if (
      genderId === GENDER_MALE_ID ||
      genderId === GENDER_FEMALE_ID ||
      genderId === null
    ) {
      return;
    }

    return (
      <div className="col-md-4">
        <SocialName {...props} />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <h3>Dados Essenciais</h3>
      </div>

      <div className="col-md-4">
        <Name {...props} required />
      </div>
      {renderSocialName()}
      <div className="col-md-4">
        <CPF {...props} required />
      </div>
      <div className="col-md-4">
        <RG {...props} required />
      </div>
      <div className="col-md-4">
        <DateOfBirth {...props} required />
      </div>
      <div className="col-md-4">
        <Ethnicity {...props} required />
      </div>
      <div className="col-md-4">
        <Gender {...props} handleChange={handleGender} required />
      </div>
      <div className="col-md-4">
        <Sex {...props} />
      </div>
      <div className="col-md-4">
        <Email {...props} required />
      </div>
      <div className="col-md-4">
        <CellPhone {...props} required />
      </div>
      <div className="col-md-4">
        <MaritalStatus {...props} required />
      </div>
      {user?.intern && (
        <div className="col-md-4">
          <InstitutionalEmail {...props} />
        </div>
      )}
      <div className="col-md-4">
        <Nationality {...props} />
      </div>
      <div className="col-md-4">
        <JobInterests {...props} />
      </div>
      <div className="col-md-12">
        <NotInUniversity {...props} handleChange={handleShowAcademic} />
      </div>
      {showAcademic ? <OldUniversityFields {...props} /> : null}

      <div className="col-md-4">
        <Working {...props} />
      </div>
      <div className="col-md-4">
        <AutoEnroll {...props} />
      </div>
      <div className="col-md-4">
        <AuthorizeWhatsapp {...props} />
      </div>
      <DisabilitySection {...props} />

      <div className="col-md-4" style={{ marginTop: "40px" }}>
        <CurriculumVitae {...props} />
      </div>
    </div>
  );
}

const OldUniversityFields = (props) => {
  return (
    <>
      <div className="col-md-6">
        <University {...props} required />
      </div>
      <div className="col-md-6">
        <Course {...props} required />
      </div>
      <div className="col-md-6">
        <CurrentSemester {...props} required />
      </div>
      <div className="col-md-6">
        <FormationDate {...props} required />
      </div>
    </>
  );
}

const NewEssential = (props) => {
  const defaultValue = props.getValues?.("main_education_type");
  const [mainEducationType, setMainEducationType] = useState(defaultValue);
  const [genderId, setGenderId] = useState(null);

  const user = store.getState().session?.attributes;

  const handleChange = (value) => {
    setMainEducationType(value);
  };

  const handleGender = (value) => {
    setGenderId(value);
  };

  const renderSocialName = () => {
    if (
      genderId === GENDER_MALE_ID ||
      genderId === GENDER_FEMALE_ID ||
      genderId === null
    ) {
      return;
    }

    return (
      <div className="col-md-4">
        <SocialName {...props} />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <h3>Dados Essenciais</h3>
      </div>

      <div className="col-md-4">
        <Name {...props} required />
      </div>
      {renderSocialName()}
      <div className="col-md-4">
        <CPF {...props} required />
      </div>
      <div className="col-md-4">
        <RG {...props} required />
      </div>
      <div className="col-md-4">
        <DateOfBirth {...props} required />
      </div>
      <div className="col-md-4">
        <Ethnicity {...props} required />
      </div>
      <div className="col-md-4">
        <Gender {...props} handleChange={handleGender} required />
      </div>
      <div className="col-md-4">
        <Sex {...props} />
      </div>
      <div className="col-md-4">
        <Email {...props} required />
      </div>
      <div className="col-md-4">
        <CellPhone {...props} required />
      </div>
      <div className="col-md-4">
        <MaritalStatus {...props} required />
      </div>
      {user?.intern && (
        <div className="col-md-4">
          <InstitutionalEmail {...props} />
        </div>
      )}
      <div className="col-md-4">
        <Nationality {...props} />
      </div>
      <div className="col-md-4">
        <JobInterests {...props} />
      </div>
      <div className="col-md-12">
        <MainEducationType {...props} handleChange={handleChange} required />
      </div>
      {mainEducationType && mainEducationType !== "none" && (
        <NewUniversityFields {...props} mainEducationType={mainEducationType} />
      )}
      <div className="col-md-4">
        <Working {...props} />
      </div>
      <div className="col-md-4">
        <AutoEnroll {...props} />
      </div>
      <div className="col-md-4">
        <AuthorizeWhatsapp {...props} />
      </div>
      <DisabilitySection {...props} />

      <div className="col-md-4" style={{ marginTop: "40px" }}>
        <CurriculumVitae {...props} />
      </div>
    </div>
  );
}

const NewUniversityFields = (props) => {
  const { mainEducationType } = props;

  const showIesAndCourse =
    mainEducationType !== "elementary_school" &&
    mainEducationType !== "high_school";

  return (
    <>
      <div className="col-md-12">
        <MainEducationStatus {...props} required />
      </div>
      {mainEducationType === "college" && (
        <div className="col-md-12">
          <IesEducationType
            {...props}
            required
            disabled={mainEducationType !== "college"}
          />
        </div>
      )}
      {showIesAndCourse && (
        <>
          <div className="col-md-12">
            <University {...props} required />
          </div>
          <div className="col-md-12">
            <Course {...props} required />
          </div>
        </>
      )}
      <div className="col-md-12">
        <IesPeriod {...props} required />
      </div>
      <div className="col-md-12">
        <FormationDate {...props} required />
      </div>
    </>
  );
};

export default (props) => {
  const { isEnabled } = useFlipper();

  if (isEnabled("user_profile_education_level")) {
    return <NewEssential {...props} />;
  } else {
    return <OldEssential {...props} />;
  }
};
